import React from 'react';
import { Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export interface FooterProps {
  /**
   * Optional data-id for testing purposes
   */
  'data-id'?: string;
}
export const Footer: React.FC<FooterProps> = ({
  'data-id': dataId
}) => {
  return <footer className="bg-neutral-100 py-16 px-8" data-id="element-244">
      <div className="max-w-7xl mx-auto" data-id="element-245">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-246">
          {/* Logo & Social */}
          <div data-id="element-247">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/web-logo.png" alt="Peterson House Logo" className="h-16 mb-8" data-id="element-248" />
            <div className="flex gap-8" data-id="element-249">
              <a href="https://www.facebook.com/PetersonHouseltd" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page" className="text-brand-pink hover:text-brand-pink/70 transition-colors" data-id="element-250">
                <Facebook className="w-5 h-5" data-id="element-251" />
              </a>
              <a href="https://www.instagram.com/petersonhouse/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Instagram page" className="text-brand-pink hover:text-brand-pink/70 transition-colors" data-id="element-252">
                <Instagram className="w-5 h-5" data-id="element-253" />
              </a>
              <a href="https://www.tiktok.com/@peterson_house" target="_blank" rel="noopener noreferrer" aria-label="Visit our TikTok page" className="text-brand-pink hover:text-brand-pink/70 transition-colors" data-id="element-254">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-255">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-256" />
                </svg>
              </a>
            </div>
          </div>
          {/* Visit */}
          <div data-id="element-257">
            <h3 className="font-serif text-neutral-900 font-medium mb-6 text-lg" data-id="element-258">
              Visit
            </h3>
            <ul className="space-y-3" data-id="element-259">
              <li data-id="element-260">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-261">
                  Cellar Door
                </a>
              </li>
              <li data-id="element-262">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-263">
                  Restaurant
                </a>
              </li>
              <li data-id="element-264">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-265">
                  Tours
                </a>
              </li>
              <li data-id="element-266">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-267">
                  Events
                </a>
              </li>
            </ul>
          </div>
          {/* Wines */}
          <div data-id="element-268">
            <h3 className="font-serif text-neutral-900 font-medium mb-6 text-lg" data-id="element-269">
              Wines
            </h3>
            <ul className="space-y-3" data-id="element-270">
              <li data-id="element-271">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-272">
                  Sparkling Wines
                </a>
              </li>
              <li data-id="element-273">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-274">
                  Wine Club
                </a>
              </li>
              <li data-id="element-275">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-276">
                  Shop Online
                </a>
              </li>
              <li data-id="element-277">
                <a href="#" className="text-neutral-600 hover:text-brand-pink transition-colors" data-id="element-278">
                  Tastings
                </a>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div data-id="element-279">
            <h3 className="font-serif text-neutral-900 font-medium mb-6 text-lg" data-id="element-280">
              Contact
            </h3>
            <ul className="space-y-4 text-neutral-600" data-id="element-281">
              <li className="inline-flex items-start gap-3" data-id="element-282">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-brand-pink" data-id="element-283" />
                <span className="leading-relaxed" data-id="element-284">
                  Corner Broke Road and Wine Country Drive
                  <br data-id="element-285" />
                  Pokolbin NSW 2320
                </span>
              </li>
              <li className="inline-flex items-center gap-3" data-id="element-286">
                <Phone className="w-4 h-4 text-brand-pink" data-id="element-287" />
                <a href="tel:0249987881" className="hover:text-brand-pink transition-colors" data-id="element-288">
                  02 4998 7881
                </a>
              </li>
              <li className="inline-flex items-center gap-3" data-id="element-289">
                <Mail className="w-4 h-4 text-brand-pink" data-id="element-290" />
                <a href="mailto:bubbles@petersonhouse.com.au" className="hover:text-brand-pink transition-colors" data-id="element-291">
                  bubbles@petersonhouse.com.au
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Copyright & Legal Links */}
        <div className="border-t border-neutral-200 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-292">
          <p className="text-neutral-600 text-sm" data-id="element-293">
            © {new Date().getFullYear()} Peterson House. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-294">
            <a href="#" className="text-neutral-600 text-sm hover:text-brand-pink transition-colors" data-id="element-295">
              Terms & Conditions
            </a>
            <span className="text-neutral-300" data-id="element-296">|</span>
            <a href="#" className="text-neutral-600 text-sm hover:text-brand-pink transition-colors" data-id="element-297">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
};